import type { Route } from './types';

/**
 * Routes redrawn as clean arcs/loops, hidden by default in the map and
 * surfaced one at a time via the route filter chips at the top of the
 * map. Heavier dose = larger loop, so the visual hierarchy reads as a
 * nested set of containers (bedroom inside relationship inside
 * lifestyle inside TPE).
 *
 * Region centres referenced by these paths:
 *   servant     (500, 170)
 *   devotee     (786, 335)
 *   sensualist  (786, 665)
 *   primal      (500, 830)
 *   brat        (214, 665)
 *   little      (214, 335)
 *
 * All arcs use the geometric center (500,500) so the four routes stack
 * neatly as concentric containers.
 */
export const ROUTES: Route[] = [
  {
    id: 'bedroom-path',
    name: 'the bedroom path',
    doseLevel: 'bedroom',
    // Tight 60-radius loop just north-east of the consent fountain —
    // contained, doesn't leave a small district.
    d: 'M 460 500 a 40 40 0 1 1 80 0 a 40 40 0 1 1 -80 0',
    description:
      "short, looping, doesn't leave a small district. scenes by appointment; life unchanged in between. the most contained of the four dose levels.",
    dashArray: '4 4',
    strokeWidth: 2,
  },
  {
    id: 'relationship-road',
    name: 'the relationship road',
    doseLevel: 'relationship',
    // Arc connecting two adjacent regions (servant and devotee).
    // Bears a partnership across the daily texture but doesn't span
    // the whole country.
    d: 'M 500 170 Q 760 200, 786 335',
    description:
      'connects two regions; bears a partnership across the daily texture. small rituals, a recognizable shape, but most of life remains itself.',
    strokeWidth: 2.5,
  },
  {
    id: 'lifestyle-highway',
    name: 'the lifestyle highway',
    doseLevel: 'lifestyle',
    // Hexagonal arc touching servant → devotee → sensualist → primal,
    // sweeping along the right half of the country. Heavy commitment
    // without yet reaching the full TPE encirclement.
    d: 'M 500 170 Q 786 200, 786 335 Q 786 500, 786 665 Q 786 800, 500 830',
    description:
      'a long road that crosses multiple regions. the dynamic shapes the calendar, the body, the attention. heavier and more committed; pace yourself.',
    strokeWidth: 3,
  },
  {
    id: 'tpe-way',
    name: 'the total power way',
    doseLevel: 'tpe',
    // Full circumferential ring at radius 330 — touches all six
    // region centres. Authority extends across nearly all of life.
    d: 'M 500 170 A 330 330 0 1 1 499 170 Z',
    description:
      "the longest, most committed route — passes near every region. authority extends across nearly all of life. real tpe is rarer in the wild than the fantasy suggests; build community, keep external eyes on the relationship, revisit the agreement often.",
    strokeWidth: 4,
  },
];
